export function getSummaryLabel(label: string, count: number | null) {
  return `${label} ${count === null ? '' : `(${count.toLocaleString()})`}`;
}
